import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import dayjs from './plugins/dayjs'
import firebase from 'firebase/app'
import 'firebase/auth'
import axios from 'axios'
import moment from 'vue-moment'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import VueApexCharts from 'vue-apexcharts'
import i18n from './i18n'

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.use(moment)
Vue.use(ElementUI, { locale })

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
axios.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`
  return config
})
axios.interceptors.response.use(
  function (response) {
    return response
  },
  async function (error) {
    if (error.response.status === 401 || error.response.status === 403) {
      if (error.response.data.message == 'token expired') {
        const token = await firebase.auth().currentUser.getIdToken(true)
        localStorage.setItem('token', token)
        error.config.headers['Authorization'] = `Bearer ${token}`
        return axios.request(error.config)
      }
      firebase
        .auth()
        .signOut()
        .then(() => {
          localStorage.removeItem('token')
        })
      return Promise.reject(error)
    }
    const title = navigator.language === 'ja' ? 'エラー' : 'Error'
    const message = navigator.language === 'ja' ? '処理に失敗しました' : 'Failed to process.'
    ElementUI.MessageBox.alert(message, title, { dangerouslyUseHTMLString: false, confirmButtonText: 'OK' })
    return Promise.reject(error)
  }
)

Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APP_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)

new Vue({
  router,
  store,
  vuetify,
  dayjs,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
